import { BrandContent } from '../types/new-car-offers'

export const BRANDS_CONTENT: BrandContent[] = [
  {
    name: 'Aston Martin',
    url: 'https://www.marshall.co.uk/aston-martin/new-cars',
    image: {
      alt: 'Aston Martin logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Audi',
    url: 'https://www.marshall.co.uk/audi/new-car-offers',
    image: {
      alt: 'Audi logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'BMW',
    url: 'https://www.marshall.co.uk/bmw/new-car-offers',
    image: {
      alt: 'BMW logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'BYD',
    url: 'https://www.marshall.co.uk/byd/new-car-offers',
    image: {
      alt: 'BYD logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'CUPRA',
    url: 'https://www.marshall.co.uk/cupra/new-car-offers',
    image: {
      alt: 'CUPRA logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Ford',
    url: 'https://www.marshall.co.uk/ford/new-car-offers',
    image: {
      alt: 'Ford logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Honda',
    url: 'https://www.marshall.co.uk/honda/new-car-offers',
    image: {
      alt: 'Honda logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Hyundai',
    url: 'https://www.marshall.co.uk/hyundai/new-car-offers',
    image: {
      alt: 'Hyundai logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'JAECOO',
    url: 'https://www.marshall.co.uk/jaecoo/new-car-offers',
    image: {
      alt: 'JAECOO logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Range Rover',
    url: 'https://www.marshall.co.uk/land-rover/new-car-offers',
    image: {
      alt: 'Range Rover logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Defender',
    url: 'https://www.marshall.co.uk/land-rover/new-car-offers',
    image: {
      alt: 'Defender logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Discovery',
    url: 'https://www.marshall.co.uk/land-rover/new-car-offers',
    image: {
      alt: 'Discovery logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Mercedes',
    url: 'https://www.marshall.co.uk/mercedes-benz/new-car-offers',
    image: {
      alt: 'Mercedes logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Mini',
    url: 'https://www.marshall.co.uk/mini/new-car-offers',
    image: {
      alt: 'Mini logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Nissan',
    url: 'https://www.marshall.co.uk/nissan/new-car-offers',
    image: {
      alt: 'Nissan logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'OMODA',
    url: 'https://www.marshall.co.uk/omoda/new-car-offers',
    image: {
      alt: 'OMODA logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'SEAT',
    url: 'https://www.marshall.co.uk/seat/new-car-offers',
    image: {
      alt: 'SEAT logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Skoda',
    url: 'https://www.marshall.co.uk/skoda/new-car-offers',
    image: {
      alt: 'Skoda logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'smart',
    url: 'https://www.marshall.co.uk/smart/new-car-offers',
    image: {
      alt: 'smart logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Volkswagen',
    url: 'https://www.marshall.co.uk/volkswagen/new-car-offers',
    image: {
      alt: 'Volkswagen logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
  {
    name: 'Volvo',
    url: 'https://www.marshall.co.uk/volvo/new-car-offers',
    image: {
      alt: 'Volvo logo',
      name: '',
      focus: '',
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/1024x340/81a19ad3be/home-hero.webp',
      copyright: '',
      fieldtype: 'asset',
    },
  },
]
